import { z } from "zod";
import { DayOfWeekSchema } from "../../types/supabase.types.gen";
import { zodDateSchema } from "../shared";
import { remunerationProfileInsertPayloadSchema } from "../remuneration/remuneration-profile";
import { contractMutationBodySchema, postContractResponseSchema } from "./mutation";

/**
 * POST /contracts/modification-amendments body: amendment modificatif contract row + optional nested profile.
 * Client must not send `remuneration_profile_id` — the API creates a dedicated profile when nested data is present.
 */
export const postModificationAmendmentBodySchema = contractMutationBodySchema
  .omit({ remuneration_profile_id: true, amendment_type: true })
  .extend({
    amendment_type: z.literal("modification"),
    contract_key: z.number().int().positive(),
    talent_id: z.guid(),
    owner_id: z.guid(),
    mission_id: z.guid(),
    agency_id: z.guid(),
    workspace_id: z.guid(),
    start_date: zodDateSchema,
    end_date: zodDateSchema,
    working_days: z.array(DayOfWeekSchema).min(1),
    hourly_wage: z.number(),
    coefficient: z.number(),
    address_id: z.guid(),
    is_sirh_request: z.boolean(),
    job_name: z.string().min(1),
    is_termination_bonus_paid_monthly: z.boolean(),
    remuneration_profile: remunerationProfileInsertPayloadSchema.optional(),
  });

export const postModificationAmendmentResponseSchema = postContractResponseSchema;

export type PostModificationAmendmentBody = z.infer<typeof postModificationAmendmentBodySchema>;
export type PostModificationAmendmentResponse = z.infer<typeof postModificationAmendmentResponseSchema>;
